export interface Bonus {
  number: string
  title: string
  tagline: string
  value: string
  image: string
  alt: string
}

export const bonuses: Bonus[] = [
  {
    number: '1',
    title: 'Master Plan: Los Primeros 30 Días',
    tagline: 'Instala autoridad y orden desde la primera clase.',
    value: '$19',
    image:
      'https://cdn.magicpatterns.com/uploads/uW92sdMRNmit31XWJr6omn/mockup-los-primeros-30-dias-de-educacion-fisica.webp',
    alt: 'Portada del Bono 1: Los primeros 30 días de Educación Física, con balón, conos y pesa en el gimnasio.',
  },
  {
    number: '2',
    title: 'Diccionario de Juegos Cero Material',
    tagline: '50 juegos sin balones, conos ni equipamiento.',
    value: '$17',
    image:
      'https://cdn.magicpatterns.com/uploads/7wBFAakQcZuLSREXvC3fXz/mockup-diccionario-de-juegos-de-cero-material.webp',
    alt: 'Portada del Bono 2: Diccionario de juegos de cero material, con estudiantes jugando en el gimnasio.',
  },
  {
    number: '3',
    title: 'Olimpiadas Escolares 360',
    tagline: 'Organiza una jornada deportiva completa con un checklist.',
    value: '$15',
    image:
      'https://cdn.magicpatterns.com/uploads/sYh9Ry9Vjexpji2yfSPAdy/mockup-olimpiadas-escolares-360.webp',
    alt: 'Portada del Bono 3: Olimpiadas Escolares 360, con estudiantes corriendo en una jornada deportiva.',
  },
  {
    number: '4',
    title: 'Banco de Exámenes y Microtareas',
    tagline: '50+ preguntas y exámenes listos para imprimir.',
    value: '$14',
    image:
      'https://cdn.magicpatterns.com/uploads/fQf8qSXeLrz4N2eAaAx94p/ChatGPT_Image_18_sept_2026,_23_31_36.webp',
    alt: 'Portada del Bono 4: Banco de exámenes teóricos y microtareas, con planillas y una tabla de evaluación.',
  },
  {
    number: '5',
    title: 'Diario del Capitán',
    tagline: '8 roles rotativos para formar liderazgo real.',
    value: '$12',
    image:
      'https://cdn.magicpatterns.com/uploads/3dSaocjyBMxeC8Ek6vJi7e/ChatGPT_Image_18_sept_2026,_23_36_32.webp',
    alt: 'Portada del Bono 5: Diario del Capitán, con la ficha semanal de liderazgo y una cinta de capitán.',
  },
]

/** Resumen corto usado en la tabla de valor. */
export const bonusValueRows: { label: string; value: string }[] = bonuses.map(
  (bonus) => ({
    label: `Bono ${bonus.number} — ${bonus.title}`,
    value: bonus.value,
  }),
)
